import { SelectorsResultProps, useEditor } from "@grapesjs/react"; // Import the editor hook
import { Delete } from "@mui/icons-material";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  IconButton,
  ListItemButton,
  ListItemIcon,
  Checkbox,
  Stack,
  Divider,
  useTheme,
} from "@mui/material";
import { AccordianChartBuilderSidebarBlock } from "features/chartLibrary";
import LightningLanderRefreshButton from "features/lightningLanders/components/LightningLanderRefreshButton";

function LightningLanderSelectorManager({
  selectors,
  addSelector,
  removeSelector,
  targets,
}: Omit<SelectorsResultProps, "selectSelector">) {
  const editor = useEditor();
  const theme = useTheme();
  const targetStr = targets.join(", ");

  return (
    <AccordianChartBuilderSidebarBlock
      title="Selector"
      sx={{ padding: 2 }}
      forcebottomborder
    >
      <Box>
        {editor?.getSelected() && (
          <>
            <Typography variant="subtitle2" mb={1}>
              Selected : {editor?.getSelected()?.getName()}{" "}
              <small>{targetStr}</small>
            </Typography>

            <List
              dense
              subheader={
                <Typography variant="body2">Selectors (Classes)</Typography>
              }
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                padding: 2,
                borderRadius: 4,
              }}
            >
              {selectors.map((selector) => (
                <ListItem
                  disablePadding
                  key={selector.getName()}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeSelector(selector);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    disableGutters
                    onClick={(e) => {
                      e.stopPropagation();
                      selector.setActive(!selector.getActive());
                      editor.SelectorManager.select(selector.getName());
                    }}
                    dense
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={selector.getActive()}
                        disableRipple
                        size="small"
                      />
                    </ListItemIcon>
                    <ListItemText primary={`.${selector.getLabel()}`} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Stack spacing={2} alignItems="flex-start" mt={1}>
              <Button
                size="extraSmall"
                variant="contained"
                color="primary"
                onClick={() => {
                  const name = prompt("Enter new selector name:");
                  if (name) {
                    addSelector(name);
                  }
                }}
              >
                Add Selector
              </Button>
              {selectors.length > 0 && (
                <>
                  <LightningLanderRefreshButton selectors={selectors} />
                </>
              )}
              <Divider />
            </Stack>
          </>
        )}
      </Box>
    </AccordianChartBuilderSidebarBlock>
  );
}

export default LightningLanderSelectorManager;
